import React from 'react'
import { getReportTexts } from 'store/store'

export default function TextReport({ix}) {
	console.log("TextReport: ", ix);
	const reportTexts = getReportTexts();
	const text = reportTexts[ix].Document;
	return (
		<div className='report-container'>
			<div className='w-full flex justify-center'>
				<p className='courier w-fit whitespace-pre-wrap'>
					{text}
				</p>
			</div>
		</div>
	)
}
